/* Éclora StormHook Umbrella — galerie, bundle, avis défilants, barre collante. Sans dépendance. */
(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-eumb-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = [].slice.call(track.children);
    var count = root.querySelector('[data-eumb-count]');
    var prev = root.querySelector('[data-eumb-prev]');
    var next = root.querySelector('[data-eumb-next]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-eumb-thumb]'));
    var current = 0;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft - pad, behavior: 'smooth' });
    }
    function paint(i) {
      current = i;
      if (count) count.textContent = (i + 1) + '/' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
        if (n === i && t.offsetParent) {
          var list = t.parentNode.parentNode;
          var li = t.parentNode;
          list.scrollTo({ left: li.offsetLeft - list.offsetLeft - (list.clientWidth - li.clientWidth) / 2, behavior: 'smooth' });
        }
      });
    }
    // L'image courante se lit sur la position de défilement : fiable aussi après un changement de largeur.
    var ticking = false;
    function sync() {
      ticking = false;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var x = track.scrollLeft + track.offsetLeft + pad;
      var best = 0, gap = Infinity;
      slides.forEach(function (sl, n) {
        var d = Math.abs(sl.offsetLeft - x);
        if (d < gap) { gap = d; best = n; }
      });
      if (best !== current) paint(best);
    }
    function requestSync() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }
    track.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    root.querySelectorAll('[data-eumb-tprev],[data-eumb-tnext]').forEach(function (b) {
      b.addEventListener('click', function () { go(current + (b.hasAttribute('data-eumb-tnext') ? 1 : -1)); });
    });
    root.addEventListener('eumb:media', function (e) {
      var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(e.detail); });
      if (i > -1) go(i);
    });
    paint(0);
  }

  function initBundle(root) {
    var form = root.querySelector('[data-eumb-bundle]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var tiers = [].slice.call(form.querySelectorAll('[data-eumb-tier]'));
    var btn = form.querySelector('[data-eumb-atc]');
    var err = form.querySelector('[data-eumb-error]');
    var addGifts = form.dataset.addGifts === 'true';

    function select(tier) {
      tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-active', on);
        t.querySelector('[data-eumb-radio]').checked = on;
      });
    }
    tiers.forEach(function (t) {
      t.querySelector('[data-eumb-radio]').addEventListener('change', function () { select(t); });
    });
    form.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('[data-eumb-swatch]')) return;
      var slot = input.closest('[data-eumb-slot]');
      if (slot && slot.dataset.eumbSlot === '1' && input.dataset.mediaId) {
        root.dispatchEvent(new CustomEvent('eumb:media', { detail: input.dataset.mediaId }));
      }
    });

    function buildItems() {
      var tier = form.querySelector('[data-eumb-tier].is-active') || tiers[0];
      var map = {};
      tier.querySelectorAll('[data-eumb-slot]').forEach(function (slot) {
        var c = slot.querySelector('[data-eumb-swatch]:checked');
        if (c) map[c.value] = (map[c.value] || 0) + 1;
      });
      var label = tier.dataset.title || '';
      var items = Object.keys(map).map(function (id) {
        var it = { id: Number(id), quantity: map[id] };
        if (Number(tier.dataset.qty) > 1) it.properties = { _pack: label };
        return it;
      });
      var up = tier.querySelector('[data-eumb-upsell]');
      if (up && up.checked && up.value) items.push({ id: Number(up.value), quantity: 1 });
      if (addGifts && tier.dataset.giftId && Number(tier.dataset.giftQty) > 0) {
        items.push({ id: Number(tier.dataset.giftId), quantity: Number(tier.dataset.giftQty), properties: { _gift: label } });
      }
      return items;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var items = buildItems();
      if (!items.length) return;
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      err.textContent = '';
      btn.disabled = true;
      btn.classList.add('is-loading');
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            err.textContent = res.j.description || res.j.message || form.dataset.errorText;
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { err.textContent = form.dataset.errorText; })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  function initReviews(root) {
    root.querySelectorAll('[data-eumb-marquee]').forEach(function (row, idx) {
      if (row.dataset.ready) return;
      row.dataset.ready = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var duration = Number(row.dataset.duration) || 30;
      var x = idx % 2 ? 180 : 0;
      var paused = false, timer = null, last = null, visible = false;
      function half() { return row.scrollWidth / 2; }
      function wrap() { var h = half(); if (h > 0) { if (x >= h) x -= h; if (x < 0) x += h; } }
      function step(t) {
        if (!visible) { last = null; return; }
        if (last == null) last = t;
        var dt = Math.min((t - last) / 1000, 0.1);
        last = t;
        if (!paused) { x += (half() / duration) * dt; wrap(); row.scrollLeft = x; }
        requestAnimationFrame(step);
      }
      function pause() { paused = true; clearTimeout(timer); }
      function resume() { clearTimeout(timer); timer = setTimeout(function () { x = row.scrollLeft; wrap(); paused = false; }, 1500); }
      row.addEventListener('touchstart', pause, { passive: true });
      row.addEventListener('touchend', resume, { passive: true });
      row.addEventListener('touchcancel', resume, { passive: true });
      row.addEventListener('mouseenter', pause);
      row.addEventListener('mouseleave', resume);
      row.addEventListener('focusin', pause);
      row.addEventListener('focusout', resume);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var was = visible;
          visible = es[0].isIntersecting;
          if (visible && !was) requestAnimationFrame(step);
        }).observe(row);
      } else { visible = true; requestAnimationFrame(step); }
    });
  }

  var stickyBound = false;
  function initSticky() {
    var bar = document.querySelector('[data-eumb-sticky]');
    if (!bar) return;
    var target = document.querySelector('[data-eumb-atc]');
    if (!target) { bar.hidden = true; return; }
    var threshold = Number(bar.dataset.threshold) || 2300;
    function drawerOpen() {
      var d = document.querySelector('cart-drawer');
      return !!(d && (d.classList.contains('active') || d.classList.contains('animate')));
    }
    function update() {
      var b = document.querySelector('[data-eumb-sticky]');
      var t = document.querySelector('[data-eumb-atc]');
      if (!b || !t) return;
      var r = t.getBoundingClientRect();
      var seen = r.bottom > 0 && r.top < window.innerHeight;
      var show = window.pageYOffset > threshold && !seen && !drawerOpen();
      b.classList.toggle('is-shown', show);
      b.setAttribute('aria-hidden', show ? 'false' : 'true');
      b.querySelector('button').tabIndex = show ? 0 : -1;
    }
    if (!stickyBound) {
      stickyBound = true;
      document.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-eumb-sticky] button');
        if (!b) return;
        var t = document.querySelector('[data-eumb-atc]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    update();
  }

  // Appli de bundle : le prix du palier choisi s'affiche dans le bouton d'achat et dans la barre collante.
  var moonTries = 0, moonHooked = false;
  function paintLivePrice(text) {
    document.querySelectorAll('[data-eumb-live-price]').forEach(function (el) {
      el.textContent = text ? (el.getAttribute('data-prefix') || '') + text : '';
    });
  }
  function hookMoon() {
    if (moonHooked || !document.querySelector('[data-eumb-live-price]')) return;
    var M = window.MoonBundle;
    var ids = M ? Object.keys(M) : [];
    var bundle = ids.length ? M[ids[0]] : null;
    if (!bundle || !bundle.currentOffer || !bundle.prices) {
      if (++moonTries < 80) setTimeout(hookMoon, 250);
      return;
    }
    moonHooked = true;
    var update = function () {
      var offer = bundle.currentOffer.get();
      var prices = bundle.prices.get();
      var p = offer && prices ? prices[offer.id] : null;
      paintLivePrice(p ? p.totalDiscountedPriceFormatted : '');
    };
    bundle.currentOffer.subscribe(update);
    bundle.prices.subscribe(update);
    update();
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-eumb-main]').forEach(function (m) { initGallery(m); initBundle(m); });
    scope.querySelectorAll('[data-eumb-reviews]').forEach(initReviews);
    initSticky();
    hookMoon();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-eumb-scroll]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
